module.exports = __webpack_public_path__ + "static/media/register1.28d6d419.png";